import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { AVAILABILITY, AvailabilityState, SHOPS_AVAILABLE } from '../availability-state';

export type AvailabilityReducers = AvailabilityState;

export function getReducers(): ActionReducerMap<AvailabilityReducers> {
  return {
    availability: StateUtils.entityLoaderReducer(AVAILABILITY),
    shopsAvailable: StateUtils.entityLoaderReducer(SHOPS_AVAILABLE),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<AvailabilityReducers>> = new InjectionToken<
  ActionReducerMap<AvailabilityReducers>
>('AvailabilityReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
